import {useContext} from "react";
import {AgentContext} from "../../context/agent-context.jsx";
import Dropzone from "../../../../../../components/dropzone/dropzone.jsx";

const Attachs = () => {
    const { user, setUser, generalAttachs, setGeneralAttachs, setChanges, attachesDescription, setAttachesDescription } = useContext(AgentContext);

    const attaches = [
        ...(user.attachs ?? []),
        ...generalAttachs,
    ];

    const setAttachs = (update) => {
        const updated = typeof update === "function" ? update(attaches) : update;

        const persistedAttachIds = new Set((user.attachs ?? []).map(attach => attach.attachId));

        const updatedPersistedAttachIds = new Set(updated.filter(attach => !attach.new).map(attach => attach.attachId));

        setUser(prev => ({
            ...prev,
            attachs: (prev.attachs ?? []).filter(attach => updatedPersistedAttachIds.has(attach.attachId))
        }));

        setGeneralAttachs(updated.filter(attach => attach.new || !persistedAttachIds.has(attach.attachId)));

        setChanges("attachs");
    }

    const updateAttachesDescription = (update) => {
        setAttachesDescription(update);
        setChanges("attachs");
    }

    return (
        <div className="h-[calc(100vh-131px)] overflow-x-hidden overflow-y-auto">
            <Dropzone
                attaches={attaches}
                setAttaches={setAttachs}
                attachesDescription={attachesDescription}
                setAttachesDescription={updateAttachesDescription}
                accept="image/*,application/pdf"
                acceptOthers={false}
            />
        </div>
    )
}

export default Attachs;
